import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AuthCallback from './pages/AuthCallback';
import ProjectsDashboard from './pages/ProjectsDashboard';
import Discovery from './pages/Discovery';
import PlanViewer from './pages/PlanViewer';
import MyProfile from './pages/MyProfile';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AcceptInvite from './pages/AcceptInvite';
import DMIPPage from './pages/DMIPPage';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/accept-invite/:token" element={<AcceptInvite />} />
            <Route path="/dmip" element={<DMIPPage />} />

            {/* Private Routes */}
            <Route
              path="/profile"
              element={
                <PrivateRoute>
                  <MyProfile />
                </PrivateRoute>
              }
            />
            <Route
              path="/projects"
              element={
                <PrivateRoute>
                  <ProjectsDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/projects/:projectId/discovery"
              element={
                <PrivateRoute>
                  <Discovery />
                </PrivateRoute>
              }
            />
            <Route
              path="/projects/:projectId/plan"
              element={
                <PrivateRoute>
                  <PlanViewer />
                </PrivateRoute>
              }
            />

            {/* Redirect unknown routes to landing page */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
